const formatCycleRuntime = (time) => {
  let cycleTime = '';
  if (time === 3600) {
    cycleTime = ' 1hr';
  } else if (time < 3600) {
    const min = Math.round(time / 60) === 1 ? ' min' : ' mins';
    if ((time / 60).toFixed(0) === '60') {
      cycleTime = ' 1hr';
    } else {
      cycleTime = `${(time / 60).toFixed(0)}${min}`;
    }
  } else if (time > 3600) {
    let hour = 1;
    if (time / 3600 > 1) {
      hour = Math.floor(time / 3600);
    }
    const remainderTime = time - (3600 * hour);
    const hr = hour === 1 ? 'h' : 'h';
    if (remainderTime === 0) {
      cycleTime = `${hour}${hr}`;
    } else {
      const min = Math.round(remainderTime / 60) === 1 ? 'm' : 'm';
      if (Math.round(remainderTime / 60) === 60) {
        hour += 1;
        cycleTime = `${hour}${hr}`;
      } else {
        cycleTime = `${hour}${hr} ${(remainderTime / 60).toFixed(0)}${min}`;
      }
    }
  }
  return cycleTime;
};

export default formatCycleRuntime;
